import i18n from "@/langsconfig/i18n";
import moment from "moment";
import type { PlacesType } from "react-tooltip";
import deepEqual from 'deep-equal';

export const GetTrueFalseValue = (check, onTrue = "", onFalse = "") => check ? onTrue : onFalse;


export const ValueReferances = (value) => {

    if (Array.isArray(value)) return { type: 'array', length: value?.length, cleared: [] }

    if (typeof value == 'string' || !!Number(value)) return { type: typeof value, cleared: "" }

    if (typeof value == 'object') return { type: 'object', cleared: ClearObject(value) }

}

export const ClearObject = (obj) => {
    let tempObj = {}

    Object.entries(obj).forEach(([key, val]) => {
        tempObj[key] = ValueReferances(val)?.cleared
    }
    )
    return tempObj
}


export const toolTipAtrributes = (
    name: string,
    position: PlacesType = "left",
    showToolTip = true,
    backgroundColor = "green"
) => {
    return showToolTip && !name ? {} :
        {
            "data-tooltip-id": "my-tooltip",
            "data-tooltip-content": i18n.t(name),
            "data-tooltip-place": position,
            "data-tooltip-background-color": backgroundColor || "#006971"
        }
}
export const IsListNotEmpty = (List) => !!List?.length

export const SkeletonMap = (Length = 1, ComponentFunction) => {
    return Array.from({ length: Length }, (_, index) => (
        ComponentFunction(`${index}_${Date.now()}`)
    ))
}

export const MapLookupValue = (lookup) => lookup?.map((item) => item.value)

export const MapLookupToStringValue = (lookup) => MapLookupValue(lookup)?.join(',')


export const FormateDate = (date) => moment(date).format("( DD - MM - YYYY )")

export const IsEqual = (value1: any, value2: any) => deepEqual(value1, value2)

